import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle() {
    if (this.element.open) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }
  }
}
